// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "._loading_loadingIcon_2KEMq {\n  color: var(--v-primary-base);\n  position: fixed;\n  z-index: 9999;\n  top: 0;\n  right: 0;\n}", "",{"version":3,"sources":["/opt/buildhome/repo/src/router/views/_loading.vue"],"names":[],"mappings":"AAgBA;EACE,4BAAA;EACA,eAAA;EACA,aAAA;EACA,MAAA;EACA,QAAA;AAfF","file":"_loading.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.loadingIcon\n  color: var(--v-primary-base)\n  position: fixed\n  z-index: 9999\n  top: 0\n  right: 0\n"]}]);
// Exports
exports.locals = {
	"loadingIcon": "_loading_loadingIcon_2KEMq"
};
module.exports = exports;
